import { render, staticRenderFns } from "./EditAoaiKeyVault.vue?vue&type=template&id=3698aaca&scoped=true"
import script from "./EditAoaiKeyVault.vue?vue&type=script&lang=js"
export * from "./EditAoaiKeyVault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3698aaca",
  null
  
)

export default component.exports